import { useEffect, useState } from "react";
import { ISelectOption } from "~/shared/ui/Fields/types";
import { useQuery } from "react-query";
import { get } from "lodash";
import { listToSelectOptions } from "~/shared/lib/ListToSelectOptions/listToSelectOptions";
import { useAppeals } from "~/entity/Appeals";
import { TFilterDealerGroup } from "~/shared/model/types";

interface IUseContactsSelectOptionsProps {
  isEnabled?: boolean;
  filter?: TFilterDealerGroup;
}

export const useContactsSelectOptions = (
  props: IUseContactsSelectOptionsProps
) => {
  const { isEnabled, filter } = props;
  const { queryKeys, getAppealContacts } = useAppeals();

  const contactPersonQuery = useQuery({
    queryKey: queryKeys.appealContacts(filter),
    queryFn: () => getAppealContacts({ dealerGroup: filter }),
    enabled: isEnabled,
  });

  const getContactsSelectOptions = () => {
    const contacts = get(contactPersonQuery.data, "data.contacts", []);
    if (contacts.length) {
      return listToSelectOptions(contacts, { label: "fullName", value: "id" });
    }
    return [];
  };

  return {
    contactsSelectOptions: getContactsSelectOptions(),
    isLoading: contactPersonQuery.isLoading,
    isError: contactPersonQuery.isError,
  };
};
